import { Selector } from "./selectors"

export const ProposalSelector = Selector


// WEBPACK FOOTER //
// ./src/state/proposal/selectors/index.ts